export enum Brands {
    Outback = 'outback',
    Carrabbas = 'carrabbas',
    Bonefish = 'bonefishgrill',
    Flemings = 'flemings',
}

export enum BrandsNames {
    OBS = 'Outback Steakhouse',
    CIG = "Carrabba's Italian Grill",
    BFG = 'Bonefish Grill',
    FPS = "Fleming's Steakhouse",
}

export type ConceptIds = 'OBS' | 'CIG' | 'BFG' | 'FPS';
